import pageHelpInfo from '../Components/HelpDocumentsInfo.vue'

new Vue({
    el: "#HeplInfoPage",
    components: {
        "page-help-info": pageHelpInfo
    }   
})


// WEBPACK FOOTER //
// ./Scripts/app/HelpInfoPage.js